import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import {
  CHARGE_PHASE,
  COMBAT_PHASE,
  END_OF_TURN,
  HERO_PHASE,
  MOVEMENT_PHASE,
  START_OF_HERO_PHASE,
  WOUND_ALLOCATION_PHASE,
} from 'types/phases'

const Artifacts = {
  'Crimson Draught': {
    effects: [
      {
        name: `Crimson Draught - Passive`,
        desc: `Effect: You can reroll charge rolls for this unit.`,
        when: [CHARGE_PHASE],
      },
    ],
  },
  /* 'Crone Blade': {
    effects: [
      {
        name: `Crone Blade`,
        desc: `Pick 1 of the bearer's melee weapons. If the unmodified hit roll for an attack made with that weapon is a 6, you can heal 1 wound allocated to the bearer after all of the bearer's attacks have been resolved.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Bloodbane Venom': {
    effects: [
      {
        name: `Bloodbane Venom`,
        desc: `Pick 1 of the bearer's melee weapons. After the bearer fights, if any wounds caused by attacks made with that weapon in that phase were allocated to an enemy model and that enemy model has not been slain, roll a dice. If the roll is equal to or greater than that model's Wounds characteristic, that model is slain.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Shadow Stone': {
    effects: [
      {
        name: `Shadow Stone`,
        desc: `Add 1 to casting rolls for the bearer when they attempt to cast a spell from the Lore of Shadows (pg 70).`,
        when: [HERO_PHASE],
      },
    ],
  }, */
  'Darkling Elixir': {
    effects: [
      {
        name: `Darkling Elixir`,
        desc: `Declare: Pick a visible friendly Daughters of Khaine unit wholly within 12" of this unit to be the target.
        Effect: Roll a dice. On a 3+, the target can immediately use the Retreat ability as if it were your movement phase.`,
        when: [END_OF_TURN],
      },
    ],
  },
  /*  'Crystal Heart': {
    effects: [
      {
        name: `Crystal Heart`,
        desc: `When the bearer attempts to cast a spell that summons an endless spell, the range of that spell is doubled.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Blood Sigil': {
    effects: [
      {
        name: `Blood Sigil`,
        desc: `You can pick 1 extra prayer for the bearer from the Prayers of the Khainite Cult (pg 71).`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Rune of Khaine': {
    effects: [
      {
        name: `Rune of Khaine`,
        desc: `The first time the bearer is slain, the bearer can fight before they are removed from play.`,
        when: [WOUND_ALLOCATION_PHASE],
      },
    ],
  }, */
  Witchbrew: {
    effects: [
      {
        name: `Witchbrew`,
        desc: `Declare: Pick a visible friendly non-Unique Daughters of Khaine unit wholly within 12" of this unit to be the target.
        Effect: Roll a dice. On a 3+, ignore negative modifiers to save rolls for the target unitl the start of your next turn.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'The Croneseers Pariahs (AoR)': {
    effects: [
      {
        name: `Blade of Prophetic Doom (AoR) - Once Per Turn`,
        desc: `Declare: Pick an enemy unit in combat with this unit to be the target. 
        Effect: Roll a dice. On a 2+: 
        If the target is not damaged, inflict 1 mortal damage on it. 
        If the target is damaged, inflict an amount of mortal damage on it equal to the roll.`,
        when: [END_OF_TURN],
      },
    ],
  },
  'Champions of the Arena (AoR)': {
    effects: [
      {
        name: `Death Razor (AoR) - Reaction: You declared a Fight ability with this unit`,
        desc: `Effect: After that Fight ability has been resolved, if any enemy models were slain by this unit's attacks made as part of that Fight ability, you can pick a friendly Champions of the Arena Priest wholly within 12" of this unit to be the target. Instead of making a chanting roll for the next Prayer ability used by the target, you can use a value of 10 for the roll that cannot be modified, even if this unit has been destroyed.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Zainthar Kai (AoR)': {
    effects: [
      {
        name: `Amulet of the Bladed Queen (AoR) - Passive`,
        desc: `Effect: This unit has Ward (5+). Add 1 to save rolls for this unit.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
} satisfies TItemDescriptions

export default tagAs(Artifacts, 'artifact')
